import s from './DiscoverBlog.module.scss'
import React, { ReactElement } from 'react'
import Slider, { Settings } from 'react-slick'
import { getFastlyUrl } from '@corratech/pylot-image'
import cn from 'classnames'
import { useDeviceType } from '@components/common/IsMobile/useDeviceType'
import { useIsArabic } from '@components/common/IsArabic/useIsArabic'
import PerfectScrollbar from 'react-perfect-scrollbar'

type WidgetConfiguration = {
    widgetConfiguration: { [key: string]: string }
    children?: ReactElement[]
    html?: string
}

const DiscoverBlogGroup = (props: WidgetConfiguration) => {
    const {
        widgetConfiguration: {
            'background-color': backgroundColor,
            'button-background-color': buttonBackgroundColor,
            'button-border-color': buttonBorderColor,
            'button-link': buttonLink,
            'button-text': buttonText,
            'button-text-color': buttonTextColor,
            heading,
            'heading-color': headingColor,
            'show-button': showButton,
            'top-heading': topHeading,
            'top-heading-color': topHeadingColor
        } = {},
        html
    } = props
    const { isMobile } = useDeviceType()
    const isArabic = useIsArabic()

    const getfastlyConfig = () => {
        return isMobile
            ? { width: 294, height: 190, quality: 100 }
            : { width: 304, height: 190, quality: 100 }
    }

    const transformHTMLToSlides = (htmlString: string) => {
        if (typeof window === 'undefined') {
            return []
        }

        const parser = new DOMParser()
        const doc = parser.parseFromString(htmlString, 'text/html')
        const postItems = doc.querySelectorAll('li.post-holder')

        return Array.from(postItems).map((item, index) => {
            const titleElement = item.querySelector('.post-title a')
            const descriptionElement = item.querySelector(
                '.post-short-description'
            )
            const imageElement = item.querySelector('img')

            const title = titleElement?.textContent?.trim() ?? 'No Title'

            let description = ''
            if (descriptionElement) {
                // Remove only <style> tags
                const clonedDescription = descriptionElement.cloneNode(
                    true
                ) as HTMLElement
                const styleTags = clonedDescription.querySelectorAll('style')
                styleTags.forEach((style) => style.remove())

                // Extract visible text content
                description =
                    clonedDescription.textContent?.trim() ?? 'No Description'
            }

            const imageUrl = imageElement?.getAttribute('src') ?? ''

            const fastlyImageUrl = getFastlyUrl({
                src: imageUrl,
                ...getfastlyConfig()
            })

            return (
                <div key={`slide-${index}`} className={cn('slideItem')}>
                    <a
                        href={titleElement?.getAttribute('href') ?? ''}
                        title={title}
                        className={cn('slideImage')}
                    >
                        {imageUrl && (
                            <img
                                src={fastlyImageUrl}
                                alt={title}
                                className={cn('slideImage')}
                                loading="lazy"
                            />
                        )}
                    </a>
                    <div className={cn('postContent')}>
                        <div className={cn('postTitle')}>{title}</div>
                        <div
                            className={cn('postDescription')}
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    </div>
                </div>
            )
        })
    }

    const slides = html ? transformHTMLToSlides(html) : []

    const backgroundStyle = {
        backgroundColor
    }

    return (
        <div className={s.BlogGroup} style={backgroundStyle}>
            {topHeading && (
                <h3 className={s.topHeading} style={{ color: topHeadingColor }}>
                    {topHeading}
                </h3>
            )}
            <h2 className={s.heading} style={{ color: headingColor }}>
                {heading}
            </h2>
            {isMobile ? (
                <PerfectScrollbar
                    style={
                        isArabic ? { direction: 'rtl' } : { direction: 'ltr' }
                    }
                >
                    <div className={['mobile-scrollbar'].join(' ')}>
                        {slides}
                    </div>
                </PerfectScrollbar>
            ) : (
                <div className={cn(s['blog-items-desktop-wrapper'])}>
                    {slides}
                </div>
            )}
            {showButton && buttonLink && buttonText && (
                <a
                    href={buttonLink}
                    className={cn('button-secondary')}
                    style={{
                        backgroundColor: buttonBackgroundColor,
                        borderColor: buttonBorderColor,
                        color: buttonTextColor
                    }}
                >
                    {buttonText}
                </a>
            )}
        </div>
    )
}

export default DiscoverBlogGroup
